import React, { useRef, useState, useEffect } from "react";
import { Dialog, DialogContent, DialogActions, DialogTitle, Typography, Button, IconButton, Paper, Grid } from "@mui/material";
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next'
import CloseIcon from '@mui/icons-material/Close';
import { deleteReport } from 'utils/Reports';

const PaperComponent = (props) => {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const DeactivateReports = ({ open, setOpen, selected, rows, setAlert, setOpenAlert }) => {
    const {t} = useTranslation()

    const [activate, setActivate] = useState('');
    const [name, setName] = useState('');
    const [id, setId] = useState(null);

    useEffect(() => {
        if (open && selected) {
            const select = rows.find((row) => row.id === selected[0]);
            setActivate(select?.status);
            setName(select?.name);
            setId(selected[0]);
        }
    }
    , [open, selected, rows]);

    const deactivateReport = async (id) => {
         const body = {
            "where_delete":{
                "id":id
            }
        }

        console.log('body:', body);
        const request = await deleteReport(body);
        if(request.result.length > 0){
            setAlert({
                msg: activate === 'Enabled' ? t('custom_reports.reports.table.dialog.deactivate.messages.deactivate_success') : t('custom_reports.reports.table.dialog.deactivate.messages.activate_success'),
                severity: 'success'
            });
            setOpenAlert(true);
            setOpen(false);
        } else {
            setAlert({
                msg: activate === 'Enabled' ?  t('custom_reports.reports.table.dialog.deactivate.messages.deactivate_error') : t('custom_reports.reports.table.dialog.deactivate.messages.activate_error'),
                severity: 'error'
            });
            setOpenAlert(true);
            setOpen(false);
        }
    }

    return (
        <Dialog
            maxWidth="xs"
            fullWidth
            open={open}
            PaperComponent={PaperComponent}
            onClose={(event, reason) =>{
                if(reason !== 'backdropClick') {
                    return;
                }
                setOpen(false)
            }}
            aria-labelledby="draggable-dialog-title"
            aria-describedby="draggable-alert-dialog-description"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            {   activate === "Enabled" ?
                t('custom_reports.reports.table.dialog.deactivate.title_deactivate') : t('custom_reports.reports.table.dialog.deactivate.title_activate')
            }
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
        <DialogContent dividers>
            <Grid container>
                <Grid size={{ xs: 10, sm: 12, md: 12, lg: 12 }}>
                    {
                        activate === 'Enabled' ?
                        <Typography variant="body1">{t('custom_reports.reports.table.dialog.deactivate.messages.deactivate')} </Typography>
                        :
                        <Typography variant="body1">{t('custom_reports.reports.table.dialog.deactivate.messages.activate')} </Typography>
                    }
                    <Typography variant="body2">{t('custom_reports.reports.table.columns.name')}: {name}</Typography>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" color="error" onClick={() => setOpen(false)}>{t('custom_reports.reports.table.dialog.deactivate.buttons.cancel')}</Button>
            <Button variant="contained" color="primary" onClick={() => deactivateReport(id)}>{ activate === 'Enabled' ? t('custom_reports.reports.table.dialog.deactivate.buttons.deactivate'): t('custom_reports.reports.table.dialog.deactivate.buttons.activate')}</Button>
        </DialogActions>
        </Dialog>
    )
}

export { DeactivateReports };